<!--
- 投融资总趋势 领域分布
- 作者：王尧
- 修改时间：2019-10-11
 -->
<template>
<div class="financing_data">
  <div class="chart_bg">
    <div class="title">
      <span class="chart_name">领域分布（亿{{params.unit_type | deal('unit')}}） &nbsp;</span>
      <!-- <Tooltip placement="bottom-start" class="tip">
                <i class="iconfont">&#xe668;</i>
                <div slot="content">
                    <p>1、投融资数据覆盖医疗健康领域；</p>
                    <p>2、本页面融资额趋势的统计均按当年平均美元汇率计算，金额<br>未知的不计算入内</p>
                    <p>3、相关统计中，目前仅向普通用户开放2011年及以后的数据；</p>
                    <p>4、原始数据采集自公开渠道，可能存在遗漏或错误信息，但我<br>们着力确保更高的可靠性；</p>
                    <p>5、如需对数据纠错或进行其他数据反馈，欢迎随时联系我们，<br>客服咨询:13627682184（微信同号）</p>
                </div>
            </Tooltip> -->

      <div class="condition">
        <div class="change-unit">
          <Dropdown @on-click="handleChangeUnit">
            <a href="javascript:void(0)">{{params.unit_type | deal('unit')}}</a>
            <DropdownMenu slot="list">
              <DropdownItem v-for="item in unit_list" :name="item.id" :key="item.id" :disabled="item.id == params.unit_type">{{ item.name }}</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
        <div class="location">
          <AddressTab @selectAddress="addressChecked"></AddressTab>
        </div>
        <!-- <div class="upload">
          <a @click="downloadEcharts"><i class="iconfont">&#xe644;</i>下载</a>
        </div> -->
      </div>
    </div>
    <div class="condition condition2" v-show="!spinShow">
      <div class="time_sel2">
        <div class="ivu-checkbox-group">
          <label class="ivu-checkbox-wrapper ivu-checkbox-default" @click="haddleChangeKey('amount')">
            <span :class="{'ivu-checkbox': true, 'ivu-checkbox-checked': showSeries.amount}">
              <span class="ivu-checkbox-inner"></span>
            </span>
            <span>融资额</span>
          </label>
          <label class="ivu-checkbox-wrapper ivu-checkbox-default" @click="haddleChangeKey('growth_rate')">
            <span :class="{'ivu-checkbox': true, 'ivu-checkbox-checked': showSeries.growth_rate}">
              <span class="ivu-checkbox-inner"></span>
            </span>
            <span>事件数</span>
          </label>
        </div>
      </div>
    </div>
    <div class="chart" id="chart" :key="page_title + name"></div>

    <div class="time_slier">
      <Slider v-model="years" range :min="2011" :step="0.01" :tip-format="sliderTipFormat" :max="moment_year" @on-change="hadleTimeSlider" class="year_slider"></Slider>
      <div style="slier_axis" class="slier_axis">
        <span v-for="item,index in slier_axis" :key="item"  :style="'left:' + (100 / (slier_axis.length - 1)) * index + '%'">{{item}}</span>
      </div>
    </div>
    <p class="data_src"><span>数据来源：动脉橙数据库</span><span>数据截止时间：{{today}}</span></p>
  </div>
  <div class="top-tip">全部<span>（{{total}}）</span>
    <Dropdown @on-click="haddleChangeSort($event, 'field')">
      <a href="javascript:void(0)">{{sort_id | dealName(sort_list)}}<i class="iconfont">&#xe6ea;</i></a>
      <DropdownMenu slot="list">
        <DropdownItem v-for="item in sort_list" :key="item.id" :name="item.id" :disabled="sort_id === item.id">{{item.name}}</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  </div>
  <div class="list_div">
    <Table :columns="columns" :data="list"></Table>
    <div class="page clear" v-if="total > 10">
      <Page :total="total" :page-size="10" :current="list_params.page" class="page_list" show-total show-elevator @on-change="handleChangePage2" ref="pages" />
    </div>
  </div>
  <Contanct></Contanct>
  <DownloadCharts v-if="visible" :visible="visible" :imgbase="imgbase" :tabTitle="name" :params="params" @closeecharts="closeEcharts"></DownloadCharts>
  <Spin fix v-if="spinShow">
    <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
    <div>Loading</div>
  </Spin>
</div>
</template>

<script>
import filter from 'js/filter'
import Contanct from '../Contanct'
import AddressTab from '../AddressTab'
import DownloadCharts from '../DownloadCharts'
import {
  financing_common
} from 'js/financing_mixins'
import echarts from 'echarts'
import {
  field_option
} from 'js/financing_chart'
import {
  trendMapTag, trendTagOfEventList
} from '../../../../service'
import moment from 'moment'

export default {
  mixins: [financing_common],
  components: {
    Contanct,
    AddressTab,
    DownloadCharts
  },
  data() {
    let _this = this
    return {
      page_title: '投融资总趋势',
      name: '领域分布',
      option: field_option,
      list: [],
      list_params: {
        user_key: this.$store.state.user_key,
        page: 1,
        sort_type: 0,
        demostic: '',
        address_id: '',
        other_address: [],
        s_time: 2011,
        e_time: parseInt(moment().format('YYYY')),
        tag_id: ''
      },
      params: {
        user_key: this.$store.state.user_key,
        demostic: '',
        address_id: '',
        s_time: 2011,
        e_time: parseInt(moment().format('YYYY')),
        unit_type: 3
      },
      showSeries: {
        amount: true,
        growth_rate: true
      },
      tags_list: []
    }
  },
  methods: {
    async getMap() {
      this.curInt = ''
      this.showSeries = {
        amount: true,
        growth_rate: true
      }
      let res = await trendMapTag(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        if (this.is_destroyed) {
          return false
        }
        // 列表数据
        this.$set(this.$data, 'tags_list', res.res)
        // 图表数据
        this.option.legend.data = ['融资额' + '|' + this.params.unit_type, '事件数']
        this.option.series[0].name = '融资额' + '|' + this.params.unit_type
        this.option.series[1].name = '事件数'

        let chart_data = res.res.slice(0, 20)
        let total_amount = [],
          event_count = [],
          tag_ids = []
        chart_data.map((a) => {
          total_amount.push(filter.amountFilter(a.total))
          event_count.push(a.event_count)
          tag_ids.push(a.tag_id)
        })
        this.option.xAxis[0].data = tag_ids
        this.option.xAxis[0].axisLabel.rotate = 30
        this.option.series[0].data = total_amount
        this.option.series[1].data = event_count
        this.echartChangeTheme2()
        this.mychart.setOption(this.option)

        this.mychart.off('click')
        this.mychart.on('click', (params) => {
          this.loginVipFlow(() => {
            this.list_params.tag_id = this.curInt !== params.dataIndex ? params.name : ''
            this.curInt = this.curInt !== params.dataIndex ? params.dataIndex : ''
            this.list_params.page = 1
            this.getList()
            this.mychart.setOption(this.option)
          })
        });
        this.spinShow = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    async getList() {
      let res = await trendTagOfEventList(this.list_params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        // 列表数据
        this.$set(this.$data, 'list', res.res)
        if (this.list_params.page == 1) {
          this.$set(this.$data, 'total', res.count)
        }
      } else {
        this.$Message.error(res.msg)
      }
    },
    haddleChangeKey(name) {
      this.loginVipFlow(() => {
        if (name == 'amount') {
          this.showSeries.amount = !this.showSeries.amount
          this.mychart.dispatchAction({
            type: this.showSeries.amount ? 'legendSelect' : 'legendUnSelect',
            name: '融资额' + '|' + this.params.unit_type
          })
        } else if (name == 'growth_rate') {
          this.showSeries.growth_rate = !this.showSeries.growth_rate
          this.mychart.dispatchAction({
            type: this.showSeries.growth_rate ? 'legendSelect' : 'legendUnSelect',
            name: '事件数'
          })
        }
      })
    },
    handleChangePage2(val) {
      this.handleChangePage(val, 'field')
    }
  },
  mounted() {
    const _this = this
    this.option.series[0].itemStyle.normal.color = function(params) {
      let color_stops = params.dataIndex === _this.curInt ? [{offset: 0,color: '#2f91a6'}, {offset: 1,color: '#2e76ad'}] : [{offset: 0,color: '#30D3EF'}, {offset: 1,color: '#31A8FD'}]
      return {
        type: 'linear',
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: color_stops
      }
    }
    this.option.series[1].symbolSize = function(item, params) {
      return params.dataIndex !== _this.curInt ? 4 : 8
    }
    this.option.xAxis[0].axisLabel.formatter = function(value) {
      let index = _this.tags_list.findIndex((a) => a.tag_id == value)
      if (_this.tags_list[index].name.length > 7) {
        return _this.tags_list[index].name.substring(0, 7) + "..."
      } else {
        return _this.tags_list[index].name
      }
    }
    this.mychart = echarts.init(document.getElementById('chart'))
    this.getMap()
    this.getList()
  },
  destroyed() {
    this.option = ''
    this.mychart = ''
  },
  watch: {
    theme_switch(val) {
      if (!this.spinShow) {
        this.showSeries = {
          amount: true,
          growth_rate: true
        }
        this.echartChangeTheme2()
        this.mychart.setOption(this.option, true)
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/financing.stylus'
</style>
